import { useEffect } from "react";

/**
 * Vertically center the third-party accessibility widget button (#VAopenMenu) on
 * the real fixed header and keep it stuck there. The widget injects asynchronously
 * and can override the global CSS rule, so we set inline !important (which beats it)
 * and re-apply a few times as it loads. Restored on unmount so other routes keep
 * the global rule. Used by routes that show the widget over the app header.
 */
export default function useA11yWidgetAlign() {
  useEffect(() => {
    const apply = () => {
      const h = document.querySelector(".site-header")?.offsetHeight;
      const va = document.getElementById("VAopenMenu");
      if (!h || !va) return;
      va.style.setProperty("position", "fixed", "important");
      va.style.setProperty("top", h / 2 + "px", "important");
      va.style.setProperty("transform", "translateY(-50%)", "important");
    };
    apply();
    // Widget injects async — re-apply a few times to catch a late load.
    const timers = [200, 600, 1500, 3000].map((ms) => setTimeout(apply, ms));
    window.addEventListener("resize", apply);
    return () => {
      window.removeEventListener("resize", apply);
      timers.forEach(clearTimeout);
      const va = document.getElementById("VAopenMenu");
      if (va) {
        va.style.removeProperty("position");
        va.style.removeProperty("top");
        va.style.removeProperty("transform");
      }
    };
  }, []);
}
